import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';

import { MCM_BASE_URL } from '../../../../util/constant/common';

@Injectable({
    providedIn: 'root',
})
export class McmBedingungService {
    #http = inject(HttpClient);

    #baseUrl = MCM_BASE_URL;

    downloadPdf(textReference: string, language: string) {
        const url = `${this.#baseUrl}/avb/pdf?language=${language}&textReference=${textReference}`;
        return this.#http.get(url, {
            responseType: 'blob',
        });
    }
}
